import axios from 'axios'

import config from '../../config'

const updateAuthUser = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/AuthUsers`
  return axios.put(url, data)
}

export default updateAuthUser
